/**
 * Assist copy shared by every surface (brief R14). Typographic apostrophes.
 * Strings marked 6.10 are the brief's section 6.10 wording, verbatim.
 */
export const commonCopy = {
  brandName: 'Afriqahome Assist',
  /** While AssistRoute waits for the mode to resolve. */
  loading: 'Loading…',
  errors: {
    /** 6.10 "Gate closed". */
    gateClosed: 'Afriqahome Assist isn’t available yet.',
    /** 6.10 "Request failed". */
    requestFailed: 'We couldn’t send your request. Check your connection and try again.',
  },
} as const;
